import React, { useState, useEffect, useRef } from "react";
import { Modal } from "@mui/material";
import styles from "./index.module.scss";
import { logErrorToCloudWatch } from "../../../utils/rum";

const CommanErrorModal = ({
	isOpen,
	onClose,
	title = "Something went wrong",
	message,
	errorCode,
	errorResponse = null,
	okOnly = false,
}) => {
	const [copied, setCopied] = useState(false);
	const copiedTimeoutRef = useRef(null);

	useEffect(() => {
		if (isOpen && errorCode) {
			logErrorToCloudWatch({
				error_code: errorCode,
				title,
				error_response: errorResponse,
			});
		}
	}, [isOpen, errorCode, title, errorResponse]);

	useEffect(() => {
		return () => {
			if (copiedTimeoutRef.current) {
				clearTimeout(copiedTimeoutRef.current);
			}
		}
	}, []);

	const handleCopy = async () => {
		try {
			if (!errorCode) {
				return;
			}

			if (navigator?.clipboard?.writeText) {
				await navigator.clipboard.writeText(String(errorCode));
			} else {
				const textArea = document.createElement("textarea");
				textArea.value = String(errorCode);
				textArea.style.position = "fixed";
				textArea.style.opacity = "0";
				document.body.appendChild(textArea);
				textArea.focus();
				textArea.select();
				document.execCommand("copy");
				document.body.removeChild(textArea);
			}

			setCopied(true);

			if (copiedTimeoutRef.current) {
				clearTimeout(copiedTimeoutRef.current);
			}

			copiedTimeoutRef.current = setTimeout(() => {
				setCopied(false);
			}, 2000);
		} catch (err) {
			console.error("Copy failed", err);
		}
	};

	return (
		<Modal
			open={isOpen}
			aria-labelledby="common error modal"
			disableAutoFocus={true}
			disableEscapeKeyDown={true}
			onClose={onClose}
		>
			<div className={styles.dialog}>
				{/* Header */}
				<div className={styles.header}>
					<svg
						width="18"
						height="18"
						fill="none"
						viewBox="0 0 24 24"
						stroke="#fff"
						strokeWidth="2.5"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
						/>
					</svg>
					<span className={styles.headerText}>{title}</span>
				</div>

				{/* Body */}
				<div className={styles.body}>
					<p className={styles.message}>{message}</p>

					 <div className={styles.errorCodeRow}>
						<span className={styles.errorCodeLabel}>Error Code</span>
						<span className={styles.errorCodePill}>{errorCode}</span>
					</div> 
				</div>

				{/* Footer */}
				<div className={`${styles.footer} ${okOnly ? styles.footerOkOnly : ""}`}>
					{!okOnly && (
						<>
							<a
								className={styles.btnTicket}
								href="https://tpoportal.loganfinance.com/hc/en-us/requests/new?ticket_form_id=5312346629275"
								target="_blank"
								rel="noopener noreferrer"
							>
								Open Support Ticket
							</a>

							<div className={styles.spacer} />

							<button
								className={`${styles.btnCopy} ${copied ? styles.copied : ""}`}
								onClick={handleCopy}
							>
								{copied ? "Copied!" : "Copy Error Code"}
							</button>
						</>
					)}

					<button className={styles.btnOk} onClick={onClose}>
						OK
					</button>
				</div>
			</div>
		</Modal>
	);
};

export default CommanErrorModal;
